import angular from 'angular'
import moment from 'moment'

export default ['$q', 'locklessService', timePickerService]

const SETTINGS_KEY = 'timePickers'
const MOMENT_FORMAT = 'HH:mm'

function timePickerService($q, locklessService) {
  this.dataPill = function dataPill() {
    return [
      {
        time: moment.utc().tz(window.org_settings.timezone),
      },
    ]
  }
  this.fetchPickers = function fetchPickers() {
    const defer = $q.defer()
    locklessService
      .fetchOrgSettings()
      .then(function fetchOrgSettingsSuccess(settings) {
        if (!Object.prototype.hasOwnProperty.call(settings, SETTINGS_KEY)) {
          settings[SETTINGS_KEY] = {}
        }
        defer.resolve(settings[SETTINGS_KEY])
      })
      .catch(function fetchOrgSettingsFailure(settings) {
        defer.reject(settings)
      })
    return defer.promise
  }

  /*
   * Datum Transformations
   */
  this.mergeDatumsIntoDatum = function(datums, transform = null) {
    let datum = {}
    let idx = 0
    transform =
      transform ||
      function(x) {
        return x
      }
    for (idx; idx < datums.length; idx++) {
      for (let [key, value] of Object.entries(datums[idx])) {
        datum[key] = transform(value)
      }
    }
    return datum
  }
  this.settingValueToMoment = function(settingValue, def) {
    /*
     * Takes in an arbitrary value, returns a Date
     */
    if (angular.isUndefined(settingValue) || settingValue === null) {
      return moment(def, MOMENT_FORMAT).toDate()
    }
    if (angular.isDate(settingValue)) {
      return moment(settingValue).toDate()
    }
    if (angular.isString(settingValue) || angular.isNumber(settingValue)) {
      return moment(settingValue, MOMENT_FORMAT).toDate()
    }
    // https://en.wikipedia.org/wiki/Fail-fast
    throw Error('Type not handled')
  }
  this.momentToSettingValue = function(value) {
    /*
     * Takes in an arbitrary value, returns a string formatted with MOMENT_FORMAT
     */
    if (angular.isUndefined(value) || value === null) {
      return value
    }
    if (angular.isDate(value)) {
      return moment(value).format(MOMENT_FORMAT)
    }
    if (angular.isString(value) || angular.isNumber(value)) {
      return value
    }
    // https://en.wikipedia.org/wiki/Fail-fast
    throw Error('Type not handled')
  }
  this.renderDateDelta = function(dayDelta, timeDelta) {
    let current = moment(new Date())
      .hours(timeDelta.getHours())
      .minutes(timeDelta.getMinutes())
    current.add(dayDelta, 'days')
    return current.toDate()
  }
  this.parseDatums = function(ns, datums) {
    let keyMap = {}
    // Merge/Complie Data
    if (Object.entries(datums).length === 0) {
      keyMap = {
        firstpick: this.renderDateDelta(
          this.DEFAULTS['alpha-day'],
          this.settingValueToMoment(this.DEFAULTS['alpha'])
        ),
        secondpick: this.renderDateDelta(
          this.DEFAULTS['beta-day'],
          this.settingValueToMoment(this.DEFAULTS['beta'])
        ),
      }
    } else {
      for (let [key, value] of Object.entries(datums)) {
        let [keyNs, keyName, type] = key.split('-')
        if (keyNs !== ns) {
          continue
        }
        if (!Object.prototype.hasOwnProperty.call(keyMap, keyName)) {
          keyMap[keyName] = {}
        }
        keyMap[keyName][type] = value
        keyMap[keyName]['ns'] = ns
      }
      // Transform Data
      for (let [key, value] of Object.entries(keyMap)) {
        keyMap[key] = this.renderDateDelta(
          value['day'],
          this.settingValueToMoment(value['time'])
        )
      }
    }
    return Object.values(keyMap)
  }.bind(this)
  /*
   * Constants
   */
  this.DEFAULTS = {
    alpha: '6:00',
    'alpha-day': 0,
    beta: '18:00',
    'beta-day': 1,
  }
}
